import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LocationService } from "../../../shared/services/location.service";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: 'app-move-location-form',
    templateUrl: './move-location-form.html',
})
export class MoveLocationForm  {
    moveToLocationId;
    fromLocationId;
    photoId;
    @Output()
    moveSuccess: EventEmitter<any> = new EventEmitter();
    
    
    constructor(
        public activeModal: NgbActiveModal,
        public locationService: LocationService,
        private toastr: ToastrService,
    ) {
    }
    
    moveLocation() {
        this.locationService.moveLocation({
            photoId: this.photoId,
            toLocation: this.moveToLocationId,
            fromLocation: this.fromLocationId,
        }).subscribe((res: any) => {
            this.moveSuccess.emit(res.Data);
            this.toastr.success('Move location successfully', 'Success');
            this.activeModal.close();
        })
    }
}
